import { createStyles, Grid, makeStyles, Theme } from "@material-ui/core";
import React, { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { IKImage } from "imagekitio-react";
import useLandingFunctions from "../../../../../hooks/useLandingFunctions";
import { PFXBasicComponent } from "../../../../../models/Interfaces";
import { selectIsMobile } from "../../../../../redux/slices/cleverlynkSlice";
import { selectComponentDimensions } from "../../../../../redux/slices/landingSlice";

interface IGallery {
  id: string;
  data: PFXBasicComponent;
}

const Gallery = ({ id, data }: IGallery) => {
  const { width, height } = useSelector(selectComponentDimensions);
  const isMobile = useSelector(selectIsMobile);

  const {} = useLandingFunctions();

  const maxHeight = useMemo(() => {
    const hght = !isMobile ? height * (data.heightMultiplier ?? 1) * 1.5 : height * (data.heightMultiplier ?? 1);
    const numCols = data.images?.reduce((p, n) => p + (n.cols ?? 1), 0) ?? 0;
    if (numCols <= 4) {
      return hght;
    } else if (numCols <= 8) {
      return hght / 2;
    } else {
      return hght / 3;
    }
  }, [data.images]);

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      container: {
        width,
        // paddingTop: 20,
      },
      root: {
        minHeight: !isMobile ? height * (data.heightMultiplier ?? 1) * 1.3 : height * (data.heightMultiplier ?? 1),
        transition: "height 400ms",
        backgroundColor: data.backgroundColor ?? "#ffffff",
        position: "relative",
      },
      item: {
        transitionProperty: "height, max-height",
        transitionDuration: "400ms",
        height: maxHeight,
        maxHeight,
      },
      image: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
      },
    })
  );

  const classes = useStyles();

  return (
    <Grid container justifyContent="center" alignItems="center" className={classes.root} id={`landing-component-${id}`}>
      <Grid item container className={classes.container} alignItems="flex-start" alignContent="flex-start">
        {(data?.images ?? []).map(i => (
          <Grid key={i.url} item xs={((i?.cols ?? 1) * 3) as any} className={classes.item}>
            <IKImage
              key={i.url}
              className={classes.image}
              path={(i.url ?? "").split("cleverlynk-imgs.s3.amazonaws.com")[1]?.replace("resized-", "")}
              transformation={[
                {
                  height: 1250,
                  width: 1250,
                },
              ]}
              loading="lazy"
              lqip={{ active: true, quality: 10, blur: 40 }}
            />
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

export default Gallery;
